/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Icon, WhiteSpace } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import EnterPassSection from "./EnterPassSection";
import EnterPhoneNumSection from "./EnterPhoneNumSection";
import VerifyCodeSection from "./VerifyCodeSection";
import NavBar from "../../components/NavBar";
import LoadingIndicator from "../../components/LoadingIndicator";
import Theme from "../../utils/Theme";
import "./index.css";
import {
  identifyMobileNumError,
  identifyPasswordError,
  validateMobileNum,
  validatePassword
} from "../../utils/FieldValidator";
import * as selectors from "../../selectors";
import * as verificationAction from "../../actions/verification";
import * as verificationSelectors from "../../selectors/verification";
import * as authAction from "../../actions/auth";

const StyledContainer = styled.div`
  background: white;
  position: absolute;
  max-width: ${Theme.MaxWidth};
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledAnimatedContainer = styled.div`
  background: white;
  min-height: 100vh;
  max-width: ${Theme.MaxWidth};
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledLeftIconContainer = styled.div`
  padding: 0 0.6em
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const StyledMainContainer = styled.div`
  margin-top: 4.1em;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

class RegisterPage extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      error: null,
      securityCode: "",
      animationClass: null,
      intervalId: null,
      countdown: 0,
      position: 1,
      mobileNumber: "",
      mobileError: "",
      mobileErrorMsg: "",
      password: "",
      passwordError: false,
      passwordErrorMsg: ""
    };
  }

  componentDidMount() {
    let intervalId = setInterval(() => {
      const currentTimeStamp = new Date().getTime() / 1000;
      const expiryTimeStamp =
        this.props.verificationItem &&
        this.props.verificationItem.expiry_datetime
          ? this.props.verificationItem.expiry_datetime.timestamp
          : null;
      const countdown = expiryTimeStamp - currentTimeStamp;

      if (countdown > 0) {
        this.setState({ countdown: countdown });
      } else {
        this.setState({ countdown: 0 });
      }
    }, 1000);

    this.setState({ intervalId: intervalId, animationClass: "slide-in-right" });
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { requestStatus, verifyStatus } = this.props;

    if (requestStatus !== nextProps.requestStatus) {
      if (nextProps.requestStatus) {
        this.updatedPosition(2);
      }
    }

    if (verifyStatus !== nextProps.verifyStatus) {
      if (nextProps.verifyStatus) {
        this.updatedPosition(3);
      }
    }
  }

  signUpAccount = (mobileNumber, password) => {
    const { securityCode } = this.state;
    const { verificationItem, signUpRequest } = this.props;
    const token = verificationSelectors.getPhoneVerificationItemToken(
      verificationItem
    );
    const submitData = {
      type: "phone",
      prefix: "+60",
      number: mobileNumber,
      password: password,
      confirm_password: password,
      token: token,
      secret: securityCode
    };
    signUpRequest(submitData);
  };

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  onPressSubmitResetRequest = () => {
    const { requestPhoneVerificationCodeRequest } = this.props;
    const { mobileNumber } = this.state;
    let submitData = {
      type: "phone",
      prefix: "+60",
      number: mobileNumber
    };

    requestPhoneVerificationCodeRequest(submitData);
  };

  onPressSubmitVerifyCode = () => {
    const { securityCode } = this.state;
    const { verificationItem, verifyPhoneVerificationCodeRequest } = this.props;
    const verificationToken = verificationSelectors.getPhoneVerificationItemToken(
      verificationItem
    );
    const submitData = {
      type: "phone",
      token: verificationToken,
      secret: securityCode
    };

    verifyPhoneVerificationCodeRequest(submitData);
  };

  onBackPressed = () => {
    const { history } = this.props;
    const { position } = this.state;

    if (position === 1) {
      this.setState({ animationClass: "slide-out-right" });

      window.setTimeout(() => {
        history.goBack();
      }, 300);
    } else {
      this.updatedPosition(position - 1);
    }
  };

  updatedPosition = position => {
    this.setState({ position: position });
  };

  onSecurityCodeChanged = value => {
    this.setState({ securityCode: value });
  };

  onMobileSubmit = mobileNumber => {
    this.validateMobileFields(mobileNumber);
    if (!mobileNumber.error) {
      this.requestPhoneVerificationCode(mobileNumber);
    }

    this.setState({
      mobileError: mobileNumber.error,
      mobileErrorMsg: mobileNumber.error_message
    });
  };

  onPasswordSubmit = password => {
    this.validatePasswordFields(password);
    if (!password.error) {
      this.onSubmitRegister(password.value);
    }

    this.setState({
      password: password.value,
      passwordError: password.error,
      passwordErrorMsg: password.error_message
    });
  };

  validatePasswordFields = password => {
    if (!validatePassword(password.value)) {
      password.error = true;
      password.error_message = identifyPasswordError(password.value);
    } else {
      password.error = false;
      password.error_message = "";
    }

    this.setState({
      password: password,
      passwordError: password.error,
      passwordErrorMsg: password.error_message
    });
  };

  validateMobileFields = mobileNumber => {
    if (!validateMobileNum(mobileNumber.value)) {
      mobileNumber.error = true;
      mobileNumber.error_message = identifyMobileNumError(mobileNumber.value);
    } else {
      mobileNumber.error = false;
      mobileNumber.error_message = "";
    }

    this.setState({
      mobileError: mobileNumber.error,
      mobileErrorMsg: mobileNumber.error_message
    });
  };

  requestPhoneVerificationCode = mobileNumber => {
    const { requestPhoneVerificationCodeRequest } = this.props;

    const mobile_number = mobileNumber.value.replace(/\s/g, "");

    const data = {
      type: "phone",
      prefix: "+60",
      number: mobile_number
    };
    requestPhoneVerificationCodeRequest(data);

    this.setState({
      mobileNumber: mobile_number
    });
  };

  onSubmitRegister = password => {
    const { mobileNumber } = this.state;
    const { setMobileNumberAndPassword } = this.props;
    setMobileNumberAndPassword &&
      setMobileNumberAndPassword(mobileNumber, password);
    this.signUpAccount(mobileNumber, password);
  };

  getNavBar = () => {
    return (
      <NavBar
        middleTitle={
          <FormattedMessage
            id="register.title"
            defaultMessage="Registration"
            description="Forgot Password Page Title"
          />
        }
        leftIcon={
          <StyledLeftIconContainer>
            <Icon type="left" size="xs" />
            <FormattedMessage
              id="app.back"
              defaultMessage="Back"
              description="Navigate to previous page"
            />{" "}
          </StyledLeftIconContainer>
        }
        onLeftIconClick={() => this.onBackPressed()}
        {...this.props}
      />
    );
  };

  getLoadingIndicator = () => {
    const { requestLoading } = this.props;
    if (requestLoading) {
      return <LoadingIndicator />;
    }

    return false;
  };

  getContent = position => {
    const {
      error,
      mobileError,
      mobileErrorMsg,
      passwordError,
      passwordErrorMsg,
      securityCode,
      countdown
    } = this.state;
    const { requestLoading } = this.props;

    switch (position) {
      case 1:
        return (
          <EnterPhoneNumSection
            loading={requestLoading}
            onMobileSubmit={this.onMobileSubmit}
            error={mobileError}
            mobileErrorMsg={mobileErrorMsg}
          />
        );
      case 2:
        return (
          <VerifyCodeSection
            loading={requestLoading}
            error={error}
            code={securityCode}
            countdown={countdown}
            onCodeChanged={this.onSecurityCodeChanged}
            onResendClicked={() => this.onPressSubmitResetRequest()}
            onSubmit={() => this.onPressSubmitVerifyCode()}
          />
        );
      case 3:
        return (
          <EnterPassSection
            loading={requestLoading}
            onPasswordSubmit={this.onPasswordSubmit}
            error={passwordError}
            errorMessage={passwordErrorMsg}
          />
        );
    }
  };

  render() {
    const { animationClass, position } = this.state;

    return (
      <StyledContainer>
        <StyledAnimatedContainer
          className={animationClass !== null ? animationClass : false}
          onAnimationEnd={() => this.setState({ animationClass: null })}
        >
          {this.getNavBar()}
          {this.getLoadingIndicator()}
          <StyledMainContainer>
            <WhiteSpace size={"md"} />
            <TransitionGroup>
              <CSSTransition key={position} timeout={300} classNames="fade">
                {this.getContent(position)}
              </CSSTransition>
            </TransitionGroup>
          </StyledMainContainer>
        </StyledAnimatedContainer>
      </StyledContainer>
    );
  }
}

RegisterPage.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  verificationItem: PropTypes.object.isRequired,
  verifyStatus: PropTypes.bool,
  requestStatus: PropTypes.bool,
  requestLoading: PropTypes.bool,
  signUpPassword: PropTypes.string,
  mobileNumber: PropTypes.string,
  requestPhoneVerificationCodeRequest: PropTypes.func.isRequired,
  verifyPhoneVerificationCodeRequest: PropTypes.func,
  setMobileNumberAndPassword: PropTypes.func.isRequired,
  signUpRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    requestStatus: selectors.getPhoneVerificationRequestStatus(state),
    verificationItem: selectors.getPhoneVerificationItem(state),
    verifyStatus: selectors.getVerifyStatus(state),
    requestLoading: selectors.getRequestPhoneVerificationLoading(state),
    signUpPassword: selectors.getPhoneVerificationPassword(state),
    mobileNumber: selectors.getMobileNumber(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    requestPhoneVerificationCodeRequest: data =>
      dispatch(verificationAction.requestPhoneVerificationCodeRequest(data)),
    verifyPhoneVerificationCodeRequest: data =>
      dispatch(verificationAction.verifyPhoneVerificationCodeRequest(data)),
    setMobileNumberAndPassword: (phone, password) =>
      dispatch(verificationAction.setMobileNumberAndPassword(phone, password)),
    signUpRequest: data => dispatch(authAction.signUpAccountRequest(data))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterPage);



// WEBPACK FOOTER //
// ./src/containers/RegisterPage/index.js